// FILE: src/components/student/provinces.js
// The 13 provinces and territories with Canada Post codes; the server stores
// the 2-letter code (backend src/utils/contactDetails.js keeps the same list).
export const PROVINCES = [
  { code: "AB", name: "Alberta" },
  { code: "BC", name: "British Columbia" },
  { code: "MB", name: "Manitoba" },
  { code: "NB", name: "New Brunswick" },
  { code: "NL", name: "Newfoundland and Labrador" },
  { code: "NT", name: "Northwest Territories" },
  { code: "NS", name: "Nova Scotia" },
  { code: "NU", name: "Nunavut" },
  { code: "ON", name: "Ontario" },
  { code: "PE", name: "Prince Edward Island" },
  { code: "QC", name: "Quebec" },
  { code: "SK", name: "Saskatchewan" },
  { code: "YT", name: "Yukon" }
];

/** "on", "Ontario", "Québec" → the 2-letter code; "" when unknown. */
export function provinceCode(value) {
  if (!value || typeof value !== "string") return "";
  const s = value
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim()
    .toLowerCase();
  const hit = PROVINCES.find((p) => p.code.toLowerCase() === s || p.name.toLowerCase() === s);
  return hit ? hit.code : "";
}

// Canada Post: no D F I O Q U; no W or Z as the first letter.
const POSTAL_RE = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]\d[ABCEGHJ-NPRSTV-Z]\d$/;

/** "m5v1a1" → "M5V 1A1"; null when it isn't a Canadian postal code. */
export function normalisePostalCode(value) {
  const compact = String(value || "")
    .toUpperCase()
    .replace(/[\s-]/g, "");
  return POSTAL_RE.test(compact) ? `${compact.slice(0, 3)} ${compact.slice(3)}` : null;
}
